export default {
    HOME: '/',
    NOT_FOUND: '/',
    LOGIN: '/login',
    EXTERNAL_LOGIN: '/external-login',
    REGISTER: '/register',
    VERIFY: '/verify',
    RESET_PASSWORD: '/reset-password',
    FORGOT_PASSWORD: '/forgot-password',
    TEST_DESCRIPTIONS: '/test-descriptions',
    SAMPLING_GUIDELINES: '/sampling-guidelines',
    FLUSHING_CONVERTING_PROCEDURE: '/flushing-converting-procedure',
    CONTACT: '/contact',
    FAQ: '/faq',
    USER_MANAGEMENT: '/user-management',
    SUBMITTED: '/submitted',
    DENIED: '/denied',
    APP_STORE: 'https://itunes.apple.com/us/app/oil-service-labs/id1108495490?ls=1&mt=8',
    SAMPLE_TRENDING_BASE: '/sample-trending/',
    SAMPLE_TRENDING_FORMAT: '/sample-trending/:reportId',
    ACCOUNT: '/account',
    SET_SECURITY: '/set-security'
}



// WEBPACK FOOTER //
// ./web-app/constants/route-constants.js